import axios from 'axios'

axios.defaults.baseURL = getBaseURL()
axios.defaults.headers.common['Authorization'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'

axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    // @TODO Кажется, что некорректно отправлять клиента в 404 или ГС

    // if (error.response.status === 404) {
    //   window.location.href = 'https://likecentre.ru/404'
    // }

    // if (error.response.status === 308) {
    //   window.location.href = error.response.data.link
    // }

    // if (error.response.status === 422) {
    //   window.location.href = 'https://likecentre.ru'
    // }

    return Promise.reject(error)
  }
)

export function isProductionDomain() {
  //return !!new RegExp(/terpay|terptage|sansoftlab|dva-tritona/).test(window.location.host)
  return true
}

function getBaseURL() {
  const defaultBackendRoutes = {
    'localhost:5173': 'http://likebusiness.localhost/api'
    // 'localhost:5173': 'https://demo.ter-pay.ru/api' // Чтобы работал дев
    // 'localhost:5173': 'https://likebusiness-api-pay.dev.likebz.net/api'
  }
  const currentHost = window.location.host

  if (defaultBackendRoutes[currentHost]) {
    return defaultBackendRoutes[currentHost]
  }

  if (isProductionDomain()) {
    return '/api'
  } else {
    const splittedDomain = window.location.host.split('.')
    splittedDomain.shift()
    const defaultRoute = splittedDomain.join('.')
    const partherSubdomain = window.location.pathname.split('/')[1]

    const backendRoute = `https://${partherSubdomain}.${defaultRoute}/api`

    return backendRoute
  }
}
